import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "MapPinAlternate.svg",
  "use": "MapPinAlternate.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"MapPinAlternate.svg\"><path d=\"M33.6,55.206a1.9583,1.9583,0,0,1-3.18,0C27.644,51.3166,16.01,34.4006,16.01,24.0207a16,16,0,0,1,32,0C48.01,34.4006,36.3766,51.3166,33.6,55.206ZM32.01,14.0209a10,10,0,1,0,10,10A10,10,0,0,0,32.01,14.0209Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol